// import { get, setCookie } from 'react-cookie';
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { Link } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import animation_gif from "./accept/animation.gif";

type MoveCategory = "defense" | "attack";

type MoveOption = {
    move: string;
    type: MoveCategory;
};

const AllMoves: MoveOption[] = [
    { move: "Уклон влево", type: "defense" },
    { move: "Уклон вправо", type: "defense" },
    { move: "Уклон назад", type: "defense" },
    { move: "Блок", type: "defense" },
    { move: "Нырок влево", type: "defense" },
    { move: "Нырок вправо", type: "defense" },
    { move: "Правый прямой", type: "attack" },
    { move: "Левый прямой", type: "attack" },
    { move: "Правый боковой", type: "attack" },
    { move: "Левый боковой", type: "attack" },
    { move: "Правый апперкот", type: "attack" },
    { move: "Левый апперкот", type: "attack" },
];

const AttackColors = ["#b00d0d", "#d13b00", "#6b0909", "#de5100"];
const DefenseColors = ["#0f8c4a", "#006f64", "#1f4f9e", "#0e5f3b"];

const randomFrom = (list: string[]) => list[Math.floor(Math.random() * list.length)];

const Game = () => {
    const [isClient, setIsClient] = useState(false);
    const [selected, setSelected] = useState<string[]>([]);
    const [chastota, setChastota] = useState(1000);
    const [start, setStart] = useState(false);
    const [attackPrint, setAttackPrint] = useState("Атака");
    const [defensePrint, setDefensePrint] = useState("Защита");
    const [attackColor, setAttackColor] = useState("#b00d0d");
    const [defenseColor, setDefenseColor] = useState("#0f8c4a");
    const [activeScreen, setActiveScreen] = useState<MoveCategory | null>(null);
    const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null);
    const [Sekundomer, SetSekundomer] = useState(0);
    

    // Определяем размер экрана только на клиенте
    const isBigScreen = useMediaQuery({ query: '(min-width: 500px)' }, undefined,
        () => setIsClient(true) // Устанавливаем флаг, что клиент загружен
    );

    const [cookies, setCookies] = useCookies();


    useEffect(() => {

        const cookieData = cookies['moves'];
        if (cookieData) {
            try {
                const parsed = JSON.parse(cookieData.toString());
                if (Array.isArray(parsed)) {
                    setSelected(parsed);
                }
            } catch (e) {
                console.error('Ошибка парсинга куки:', e);
            }
        }
        setIsClient(true); // Устанавливаем флаг клиента
    }, [cookies]);

    useEffect(() => {
        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [intervalId]);

    const startGame = () => {
        if (selected.length < 1 || chastota <= 0) {
            return;
        }

        let sekundomer = 0;
        SetSekundomer(0);
        setAttackPrint("Атака");
        setDefensePrint("Защита");

        const selectedMap = new Map(AllMoves.map((move) => [move.move, move.type]));
        let lastMove = "";
        const id = setInterval(() => {
            sekundomer += chastota / 1000;
            SetSekundomer(sekundomer);

            const pool =
                lastMove === "Уклон назад" && selected.length > 1
                    ? selected.filter((item) => item !== "Уклон назад")
                    : selected;

            const currentMove = randomFrom(pool);
            const moveType = selectedMap.get(currentMove);

            if (!moveType) return;

            lastMove = currentMove;

            setActiveScreen(moveType);

            if (moveType === "attack") {
                setAttackPrint(currentMove);
                setAttackColor(randomFrom(AttackColors));
            } else {
                setDefensePrint(currentMove);
                setDefenseColor(randomFrom(DefenseColors));
            }
        }, chastota);
        
        setIntervalId(id);
        setStart(true);
    };

    const endGame = () => {
        if (intervalId) clearInterval(intervalId);
        setCookies('moves', JSON.stringify(selected));
        setStart(false);
        setAttackPrint("Атака");
        setDefensePrint("Защита");
        setAttackColor("#b00d0d");
        setDefenseColor("#0f8c4a");
        setActiveScreen(null);
        SetSekundomer(0);
    };

    const canStart = selected.length >= 1 && chastota > 0;

    return (
        <div className='Game'>
            <header className="game-header">
                <Link to={'/'} className="game-back-link">На главную</Link>
                <p>Тренажер реакции</p>
            </header>
            <div className="game-layout">
                {/* Рендерим только на клиенте после гидратации */}
                {start ? (
                    <main className="game-arena">
                        <div className="arena-meta">{Sekundomer.toFixed(1)} сек.</div>
                        <div className="arena-split">
                            <div className={`arena-screen ${activeScreen === "attack" ? "is-active" : "is-inactive"}`}>
                                <div className="arena-label">Атака</div>
                                <div className="print print--attack" style={{ background: attackColor }}>
                                    <span>{attackPrint}</span>
                                </div>
                            </div>
                            <div className={`arena-screen ${activeScreen === "defense" ? "is-active" : "is-inactive"}`}>
                                <div className="arena-label">Защита</div>
                                <div className="print print--defense" style={{ background: defenseColor }}>
                                    <span>{defensePrint}</span>
                                </div>
                            </div>
                        </div>
                        <button type="button" className="arena-stop" onClick={endGame}>
                            Закончить
                        </button>
                    </main>
                ) : (
                    <section className="game-setup">
                        {isClient && isBigScreen && !start && (
                            <div className="game-animation-wrap">
                                <img className='animation_box' src={animation_gif} alt="Тренировка" />
                            </div>
                        )}
                        <div className="game-panel">
                            <div className="game-panel__head">
                                <h1>Настройка раунда</h1>
                                <p>Выбери действия и задай темп смены команд.</p>
                                <div className="game-chips">
                                    <span>Выбрано: {selected.length}</span>
                                </div>
                            </div>
                            <div>
                                <div className="field-label">Частота (миллисекунды)</div>
                                <input
                                    className="game-input"
                                    type="number"
                                    onChange={e => {
                                        const line = e.target.value;
                                        setChastota(Number(line));
                                    }}
                                    value={String(chastota).replace(/^0+/, '')}
                                    min="100"
                                />
                                <div className="field-help">*чем меньше значение, тем быстрее смена</div>
                                <hr />
                                <div className="field-label">Выберите действия:</div>
                                <div className="select">
                                    {AllMoves.map((e, id) => (
                                        <button
                                            type="button"
                                            key={id}
                                            className={`item item--${e.type} ${selected.includes(e.move) ? "is-active" : ""}`}
                                            onClick={() => {
                                                if (selected.includes(e.move)) {
                                                    setSelected(selected.filter(i => i !== e.move));
                                                } else {
                                                    setSelected([...selected, e.move]);
                                                }
                                            }}
                                        >
                                            {e.move}
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div className='btns'>
                                <button type="button" className='clear' onClick={() => {
                                    setSelected([]);
                                    setChastota(1000);
                                }}>
                                    <span>сбросить</span>
                                </button>
                                <button
                                    type="button"
                                    className="Start" 
                                    onClick={startGame}
                                    disabled={!canStart}
                                >
                                    Начать раунд
                                </button>
                            </div>
                            {!canStart && (
                                <div className="game-warning">
                                    Для старта нужно выбрать хотя бы 1 действие.
                                </div>
                            )}
                        </div>
                    </section>
                )}
            </div>
        </div>
    );
};

export default Game;